import React from "react";
import Layout from "../common/layouts";
import { graphql } from "gatsby";
import "tachyons";
import SoundCloudMultiPlayer from "./components/SoundCloudMultiPlayer";
import PodcastListItem from "./components/PodcastListItem";
import PodcastButtonsSideBox from "./components/PodcastButtonsSideBox";
// import { red } from "ansi-colors";
// import SignatureCanvas from "react-signature-canvas";

export default ({ data }) => {
  // console.log("data: ", data);
  return (
    <Layout>
      <div className="ph1 ph4-ns">
        <h1 className="f4 f3-m f2-l ph2">
          Willamette Investors Network Multifamily Show
        </h1>

        {/* ReactDOM.render(
        <SignatureCanvas
          penColor="black"
          canvasProps={{ width: 500, height: 200, className: "sigCanvas" }}
        />
        , document.getElementById('react-container') ) */}

        <div class="flex flex-wrap">
          <div class="w-100 w-80-ns">
            <SoundCloudMultiPlayer />
          </div>
          <div class="w-100 w-20-ns">
            <PodcastButtonsSideBox />
          </div>
        </div>

        {data.mdx.edges.map(({ node }) => (
          <>
            {new Date(node.childMarkdownRemark.frontmatter.publishdate) <
              new Date() && (
              <PodcastListItem
                episode={node.childMarkdownRemark.frontmatter.episode}
                guest={node.childMarkdownRemark.frontmatter.guest}
                title={node.childMarkdownRemark.frontmatter.title}
                guid={node.childMarkdownRemark.frontmatter.guid}
                previewText={node.childMarkdownRemark.frontmatter.previewText}
                coverart={node.childMarkdownRemark.frontmatter.coverart}
                webheader={node.childMarkdownRemark.frontmatter.webheader}
              />
            )}
          </>
        ))}
      </div>
    </Layout>
  );
};

export const podcastQuery = graphql`
  query {
    mdx: allFile(
      filter: {
        childMarkdownRemark: { frontmatter: { type: { eq: "podcast" } } }
      }
      sort: { fields: childMarkdownRemark___frontmatter___episode, order: DESC }
    ) {
      edges {
        node {
          childMarkdownRemark {
            frontmatter {
              episode
              guest
              title
              publishdate
              previewText
              coverart {
                childImageSharp {
                  fixed(width: 256) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
              webheader {
                childImageSharp {
                  fluid(maxWidth: 500) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            html
          }
        }
      }
    }
  }
`;
